import React from 'react'
import PropTypes from 'prop-types'
import { Form, Typography, Switch } from 'antd'
import SelectF from '@/i2antdV5/SelectF'

const FormItem = Form.Item

/**
 * baseProps 契约：
 * - ruleName：源规则名称（展示用）
 * - storeOptions：目标门店下拉（已排除源门店）
 */
class NotificationRuleCopyForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    baseProps: PropTypes.object
  }

  static defaultProps = {
    baseProps: {}
  }

  render () {
    const { form, baseProps = {} } = this.props
    const { ruleName = '', storeOptions = [] } = baseProps

    return (
      <Form ref={form} layout="vertical" initialValues={{ overwrite: false }}>
        {ruleName ? (
          <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
            将规则「{ruleName}」拷贝到以下门店（不含当前所属门店）。
          </Typography.Paragraph>
        ) : null}
        <FormItem
          label="目标门店"
          name="targetStoreIds"
          rules={[{ required: true, message: '请选择至少一个目标门店' }]}
        >
          <SelectF
            options={storeOptions}
            modalProps={{
              mode: 'multiple',
              placeholder: '请选择目标门店',
              maxTagCount: 'responsive'
            }}
          />
        </FormItem>
        <FormItem
          label="是否覆盖已存在"
          name="overwrite"
          valuePropName="checked"
        >
          <Switch checkedChildren="是" unCheckedChildren="否" />
        </FormItem>
      </Form>
    )
  }
}

export default NotificationRuleCopyForm
